import { render, staticRenderFns } from "./VideoGenerator.vue?vue&type=template&id=810a941e&scoped=true"
import script from "./VideoGenerator.vue?vue&type=script&lang=js"
export * from "./VideoGenerator.vue?vue&type=script&lang=js"
import style0 from "./VideoGenerator.vue?vue&type=style&index=0&id=810a941e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810a941e",
  null
  
)

export default component.exports